// extracted by mini-css-extract-plugin
export default {"container":"CSHm0qysQUt_BUkorBck","headline":"_f1vSESGmcIfDIzvXVBS","shareButtons":"CrgJPQ_ec2iLlYQ7jejH"};